// extracted by mini-css-extract-plugin
module.exports = {"small":"small__37PE6","large":"large__1894E"};